import { Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { EditProtectiveMeasure } from '../../model/assessment.model';
import { TranslocoDirective } from '@jsverse/transloco';
import { DarkButtonComponent } from '../../../shared/buttons/dark-button.component';
import { EditMeasureComponent } from '../edit-measure/edit-measure.component';

@Component({
  selector: 'sibat-add-protective-measure',
  template: `
    <div
      *transloco="let t; read: 'building.assessment.protectiveMeasuresForm'"
      [class.read-only]="readOnly"
      data-testid="sibat-add-measure"
    >
      <h4>
        {{ t('title') }}
      </h4>
      @if (!addingMeasure) {
      <sibat-dark-button
        (clicked)="addingMeasure = true"
        [label]="t('addMeasure')"
        [disabled]="readOnly"
        icon="add"
        class="add-measure-button"
        data-testid="add-measure"
      >
      </sibat-dark-button>
      } @if (addingMeasure) {
      <div class="add-new-measure">
        <h4>
          {{ t('addMeasure') }}
          <sibat-dark-button (clicked)="addingMeasure = false" [label]="t('cancel')" class="cancel"> </sibat-dark-button>
        </h4>
        <sibat-edit-measure (measureSaved)="addMeasure($event)"></sibat-edit-measure>
      </div>
      }
    </div>
  `,
  animations: [trigger('fadeIn', [transition('void => *', [style({ opacity: 0 }), animate(400)])])],
  styleUrls: ['add-protective-measure.component.scss'],
  imports: [TranslocoDirective, DarkButtonComponent, EditMeasureComponent],
})
export class AddProtectiveMeasureComponent {
  @Input() readOnly: boolean;
  @Output() measureAdded = new EventEmitter<EditProtectiveMeasure>();
  addingMeasure = false;

  addMeasure(newMeasure: EditProtectiveMeasure) {
    this.measureAdded.emit(newMeasure);
    this.addingMeasure = false;
  }
}
